// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Design/components/SafetyBarrierMethod/styles.scss
// module id = 1276
// module chunks = 0